import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { InvolvedParty } from './involved-party.model';
import { QueryResult, DocumentQueryParams } from '../../../core/store/models/query.model';
import { HttpService } from 'src/app/modules/core/services/http.service';
import { DocumentReader } from 'src/app/modules/core/store/models/document-reader';
import { Attachment } from 'src/app/modules/core/store/models/attachment.model';
import { HistoryDocuments} from 'src/app/modules/core/store/models/document.model';

import { API_BASE_URL as apiBaseUrl } from '@app/core/constants/api-base-url';

@Injectable({
  providedIn: 'root'
})
export class InvolvedPartyApiService {
  constructor(private http: HttpService) { }

  // Involved Party
  public createInvolvedParty(datasetUId: string, involvedParty: InvolvedParty): Observable<InvolvedParty[]> {
    const url = `${apiBaseUrl}/v1/data/datasets/${datasetUId}/documents`;

    const createRequest = {
      documents: [involvedParty]
    };

    return this.http.post<InvolvedParty[]>(url, createRequest);
  }

  public updateInvolvedParty(datasetUId: string, involvedParty: InvolvedParty): Observable<InvolvedParty[]> {
    const url = `${apiBaseUrl}/v1/data/datasets/${datasetUId}/documents`;

    const updateRequest = {
      documents: [involvedParty]
    };

    return this.http.put<InvolvedParty[]>(url, updateRequest);
  }

  public deleteInvolvedParty(datasetUId: string, involvedParty: InvolvedParty): Observable<void> {
    const reader = new DocumentReader(involvedParty);

    const url = `${apiBaseUrl}/v1/data/datasets/${datasetUId}/documents/${reader.uId}`;

    return this.http.delete(url);
  }

  public getInvolvedParties(incidentDatasetUId: string, incidentUId: string, involvedPartyDatasetUId: string, query: DocumentQueryParams): Observable<QueryResult<InvolvedParty>> {
    const queryString = this.http.queryStringFromObject({ includeCount: true });

    const url = `${apiBaseUrl}/v1/data/datasets/${involvedPartyDatasetUId}/query?${queryString}`;

    return this.http.post(url, query);
  }
}
